(() => {
  if (window.MCBlogSliderControls) return

  const connectedSliders = new WeakSet()

  const connectSlider = (sliderElement) => {
    if (connectedSliders.has(sliderElement)) return

    let attempts = 0

    const waitForSwiper = () => {
      const slider = sliderElement.slider
      const navigation = sliderElement.querySelector('[data-mc-blog-navigation]')

      if (!slider) {
        attempts += 1
        if (attempts < 120) window.requestAnimationFrame(waitForSwiper)
        return
      }

      connectedSliders.add(sliderElement)

      const syncNavigation = () => {
        if (!navigation) return

        navigation.classList.toggle('d-none', slider.isLocked)
        navigation.classList.toggle('d-flex', !slider.isLocked)
      }

      ;['lock', 'unlock', 'resize', 'breakpoint', 'update', 'slidesLengthChange'].forEach((eventName) => {
        slider.on(eventName, syncNavigation)
      })

      slider.update()
      syncNavigation()
    }

    waitForSwiper()
  }

  const connectSliders = (container = document) => {
    container.querySelectorAll('[data-mc-blog-slider]').forEach(connectSlider)
  }

  connectSliders()

  document.addEventListener('shopify:section:load', (event) => {
    connectSliders(event.target)
  })

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mc-blog-prev], [data-mc-blog-next]')
    if (!button) return

    const sliderElement = button.closest('[data-mc-blog-slider]')
    if (!sliderElement?.slider) return

    if (button.hasAttribute('data-mc-blog-prev')) {
      sliderElement.slider.slidePrev()
    } else {
      sliderElement.slider.slideNext()
    }
  })

  window.MCBlogSliderControls = { connectSliders }
})()
